import React, { useEffect, useState } from 'react'
import { object } from 'yup';
import objectToFormData from '../utils/objectToFormData';
import { hideLoader, showLoader } from '../store/loaderSlice';
import { useDispatch } from 'react-redux';
import axiosInstance from '../utils/axiosInstance';
import axios from 'axios';
import baseUrl from '../utils/urls';

const Demo = () => {
    const dispatch = useDispatch()
    const [files, setFiles] = useState([]);
    const [printItems, setPrintItems] = useState([]);
    const [formData] = useState({
        customer_id: '08f1c764-206d-4c15-aa04-fef7e1ed4156',
        store_id: 'd8d813bb-e7a4-4f7a-af52-5d5ebaca52e3',
        name: 'PAN Card',
        status_id: 1,
        payment_method_id: '20a0ea2e-6e9e-4521-b622-c05666a91159',
        delivery_slot_id: '9d2eca56-7de9-45e7-9081-1312686a04d6',
        order_sequence_id: 1,
        total_price: 10,
        is_scheduled: false,
        schedule_date: new Date(),
        file: files,
        isItemsAdded: false
    });
    console.log({ files: files })
    useEffect(() => {
        const print_costs = { Colored: 2, Lamination: 10 }

        if (files.length)
            setPrintItems(Object.values(files).map((file, index) => ({
                print_request_id: null,
                qty: index + 1,
                price: Object.values(print_costs).reduce((a, c) => a + c, 0),
                num_of_pages: 2,
                file: file,
                file_url: null,
                file_ext: null,
                print_costs: print_costs,
                is_colored: Object.keys(print_costs).some(pc => pc === 'Colored')
            })))
    }, [files]);

    const createPrintRequest = () => {
        dispatch(showLoader('Print Request Creating...'))
        axiosInstance.post(baseUrl + '/print-requests', { ...formData, files: files.length },
        ).then(async res => {
            dispatch(showLoader('Print Request Items Creating...'))
            const print_request_id = res.data.data.id
            // console.log(res.data.data)
            const printRequestItems = printItems.map((pi, index) => ({ ...pi, is_first_file: index === 0, print_request_id: res.data.data.id, print_costs: JSON.stringify(pi.print_costs) }));
            const requests = printRequestItems
                .map(pi => axiosInstance.post(baseUrl + '/print-requests/print-items', objectToFormData(pi)));

            await Promise.allSettled(requests)
                .then(res => {
                    console.log('Items Added', res.data);
                    axiosInstance.post(baseUrl + '/print-requests/mark-items-added', {
                        print_request_id: print_request_id
                    })
                })
                .catch(err => { console.log('Error Reponse', err) })
            dispatch(hideLoader());


        })
    }

    return (
        <div>
            <button onClick={createPrintRequest} >Create Print Request</button>

            <br />
            <input
                accept="image/*,.pdf"
                type="file" name="" id="" multiple
                onChange={e => setFiles(e.target.files)}
            />

            <p>Print Request</p>
            {JSON.stringify(formData)}
            {/* <ReactJson src={formData} /> */}

            <p>Print Items</p>
            {JSON.stringify(printItems)}

            {/* <ReactJson src={printItems} /> */}

        </div>
    )
}

export default Demo